// src/utils/currencyConfigs.js
export const CURRENCY_CONFIGS = {
    USD: { 
      symbol: '$', 
      code: 'USD', 
      name: 'US Dollar',
      scale: 1,
      min: 1000,
      max: 200000,
      step: 1000
    },
    GBP: { 
      symbol: '£', 
      code: 'GBP', 
      name: 'British Pound',
      scale: 0.8,
      min: 5000,
      max: 200000,
      step: 5000
    },
    EUR: {
      symbol: '€',
      code: 'EUR',
      name: 'Euro',
      scale: 0.9,
      min: 1000,
      max: 180000,
      step: 1000
    },
    AUD: {
      symbol: 'A$',
      code: 'AUD',
      name: 'Australian Dollar',
      scale: 1.3,
      min: 5000,
      max: 260000,
      step: 5000
    },
    CAD: {
      symbol: 'C$',
      code: 'CAD',
      name: 'Canadian Dollar',
      scale: 1.25,
      min: 5000,
      max: 250000,
      step: 5000
    },
    JPY: {
      symbol: '¥',
      code: 'JPY',
      name: 'Japanese Yen',
      scale: 140,
      min: 100000,
      max: 28000000,
      step: 100000
    },
    INR: {
      symbol: '₹',
      code: 'INR',
      name: 'Indian Rupee',
      scale: 100,
      min: 100000,
      max: 20000000,
      step: 100000
    },
    CNY: {
      symbol: '¥',
      code: 'CNY',
      name: 'Chinese Yuan',
      scale: 7,
      min: 10000,
      max: 1400000,
      step: 10000
    },
    SGD: {
      symbol: 'S$',
      code: 'SGD',
      name: 'Singapore Dollar',
      scale: 1.4,
      min: 5000,
      max: 280000,
      step: 5000
    },
    ZAR: {
      symbol: 'R',
      code: 'ZAR',
      name: 'South African Rand',
      scale: 20,
      min: 20000,
      max: 4000000,
      step: 20000
    }
  };
  
  export const SORTED_CURRENCIES = Object.values(CURRENCY_CONFIGS)
    .sort((a, b) => a.name.localeCompare(b.name));